import { useEffect, useState } from 'react';
import { fetchPlatformIntegrations } from '../../services/integrations';

function formatTime(value) {
  const date = value?.toDate ? value.toDate() : new Date(value);
  if (Number.isNaN(date.getTime())) return '-';
  return date.toLocaleString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
}

export default function ApiKeys() {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    fetchPlatformIntegrations().then(setConfig);
  }, []);

  if (!config) {
    return <div className="wb-skeleton wb-skeleton--large" />;
  }

  const meta = config.apiKeys?.metaWhatsApp || {};

  return (
    <div className="wb-stack">
      <section className="wb-card wb-card--elevated">
        <div className="wb-card-head">
          <div>
            <h3 className="wb-section-title">Platform Integrations</h3>
            <p className="wb-muted">Read-only inventory of platform-level credentials and provider status.</p>
          </div>
          <span className="wb-status-pill is-online">Audit view</span>
        </div>

        <div className="wb-integration-audit-card">
          <div>
            <h4>Meta / WhatsApp</h4>
            <p>Phone Number ID: <strong>{meta.phoneNumberId || '-'}</strong></p>
            <p>Token status: <span className="wb-status-pill is-online">{meta.tokenStatus || 'Valid'}</span></p>
            <p>Last used: <strong>{formatTime(meta.lastUsedAt)}</strong></p>
          </div>
        </div>
      </section>
    </div>
  );
}
